import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObservablePipe } from './observable.pipe';

@NgModule({
  declarations: [ObservablePipe],
  imports: [CommonModule],
  exports: [ObservablePipe],
  providers: [ObservablePipe]
})
export class ObservablePipeModule { }
